import styled, { keyframes } from 'styled-components';

const animationLoadingRotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

export const animationLoadingDash = keyframes`
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 150, 200;
    stroke-dashoffset: -50;
  }
  100% {
    stroke-dasharray: 150, 200;
    stroke-dashoffset: -185;
  }
`;

export const StyledSvg = styled.svg`
  animation: ${animationLoadingRotate} 2s linear infinite;
  position: relative;
`;

export const StyledCircle = styled.circle`
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: ${animationLoadingDash} 1.5s ease-in-out infinite;
  stroke-linecap: round;
  fill: transparent;
`;
